(function () {
  var mobileQuery = window.matchMedia('(max-width: 749px)');
  var searchTimer;
  var searchController;
  var emptyTimer;
  var modal;
  var input;
  var list;
  var heading;
  var popularProductsCache;

  function makeItem(product) {
    var link = document.createElement('a');
    link.className = 'cp-mobile-search-modal__item';
    link.href = product.url;
    if (product.image) {
      var image = document.createElement('img');
      image.className = 'cp-mobile-search-modal__image';
      image.src = product.image;
      image.alt = product.title || '';
      link.appendChild(image);
    }
    var title = document.createElement('span');
    title.className = 'cp-mobile-search-modal__item-title';
    title.textContent = product.title || '';
    link.appendChild(title);
    return link;
  }

  function showProducts(products, title) {
    list.replaceChildren();
    heading.textContent = title;
    products.forEach(function (product) { list.appendChild(makeItem(product)); });
  }

  function showMessage(message) {
    list.replaceChildren();
    heading.textContent = 'ძიების შედეგები';
    var element = document.createElement('p');
    element.className = 'cp-mobile-search-modal__empty';
    element.textContent = message;
    list.appendChild(element);
  }

  function loadPopularProducts() {
    if (popularProductsCache) return Promise.resolve(popularProductsCache);
    return fetch('/collections/' + encodeURIComponent('სიახლე') + '/products.json?limit=4', { credentials: 'same-origin' })
      .then(function (response) { if (!response.ok) throw new Error('Popular products request failed'); return response.json(); })
      .then(function (data) {
        popularProductsCache = (data.products || []).map(function (product) {
          return {
            title: product.title,
            url: '/products/' + product.handle,
            image: product.featured_image || product.images && product.images[0] && product.images[0].src || ''
          };
        });
        return popularProductsCache;
      });
  }

  function resetToPopular() {
    window.clearTimeout(emptyTimer);
    heading.textContent = 'პოპულარული პროდუქტები';
    list.replaceChildren();
    loadPopularProducts()
      .then(function (products) {
        if (input && !input.value.trim()) showProducts(products, 'პოპულარული პროდუქტები');
      })
      .catch(function () {
        if (input && !input.value.trim()) showMessage('პროდუქტები ვერ ჩაიტვირთა. გთხოვთ, სცადეთ კიდევ ერთხელ.');
      });
  }

  function productsFromSearchPage(html) {
    var result = new DOMParser().parseFromString(html, 'text/html');
    var seen = {};
    var products = [];
    result.querySelectorAll('.list-view-item .product-card--list, .product-card--list').forEach(function (card) {
      var title = card.querySelector('.product-card__title');
      var link = card.querySelector('.full-width-link') || title && title.closest('a');
      if (!title || !link || !link.href || seen[link.href]) return;
      seen[link.href] = true;
      var image = card.querySelector('.list-view-item__image, .product-card__image-wrapper img, img');
      products.push({ url: link.href, title: title.textContent.trim(), image: image ? image.currentSrc || image.src : '' });
    });
    return products;
  }

  function search(query) {
    if (!query) { resetToPopular(); return; }
    if (searchController) searchController.abort();
    window.clearTimeout(emptyTimer);
    searchController = new AbortController();
    var endpoint = new URL('/search', window.location.origin);
    endpoint.searchParams.set('q', query);
    endpoint.searchParams.set('type', 'product');
    endpoint.searchParams.set('options[prefix]', 'last');

    fetch(endpoint.toString(), { credentials: 'same-origin', headers: { Accept: 'text/html' }, signal: searchController.signal })
      .then(function (response) { if (!response.ok) throw new Error('Search request failed'); return response.text(); })
      .then(function (html) {
        if (!input || input.value.trim() !== query) return;
        var products = productsFromSearchPage(html);
        if (products.length) { showProducts(products, 'ძიების შედეგები'); return; }
        emptyTimer = window.setTimeout(function () {
          if (input && input.value.trim() === query) showMessage('პროდუქტი ვერ მოიძებნა');
        }, 750);
      })
      .catch(function (error) {
        if (error.name !== 'AbortError') showMessage('ძიების შედეგები ვერ ჩაიტვირთა. გთხოვთ, სცადეთ კიდევ ერთხელ.');
      });
  }

  function createModal() {
    if (modal) return;
    modal = document.createElement('div');
    modal.className = 'cp-mobile-search-modal';
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML = '<section class="cp-mobile-search-modal__panel" role="dialog" aria-modal="true" aria-labelledby="CpMobileSearchTitle"><div class="cp-mobile-search-modal__top"><h2 id="CpMobileSearchTitle" class="cp-mobile-search-modal__title">ძიება</h2><button type="button" class="cp-mobile-search-modal__close" aria-label="ძიების დახურვა"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5 19 19M19 5 5 19" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2"/></svg></button></div><div class="cp-mobile-search-modal__input-wrap"><input class="cp-mobile-search-modal__input" type="search" autocomplete="off" placeholder="ჩაწერეთ დასახელება" aria-label="ჩაწერეთ დასახელება"><span class="cp-mobile-search-modal__icon" aria-hidden="true"><svg viewBox="0 0 24 24"><circle cx="10.5" cy="10.5" r="6.5"/><path d="m16 16 4.5 4.5"/></svg></span></div><div class="cp-mobile-search-modal__content"><h3 class="cp-mobile-search-modal__heading">პოპულარული პროდუქტები</h3><div class="cp-mobile-search-modal__list"></div></div></section>';
    document.body.appendChild(modal);
    input = modal.querySelector('.cp-mobile-search-modal__input');
    list = modal.querySelector('.cp-mobile-search-modal__list');
    heading = modal.querySelector('.cp-mobile-search-modal__heading');
    modal.querySelector('.cp-mobile-search-modal__close').addEventListener('click', close);
    modal.addEventListener('click', function (event) { if (event.target === modal) close(); });
    input.addEventListener('input', function () {
      var query = input.value.trim();
      window.clearTimeout(searchTimer);
      window.clearTimeout(emptyTimer);
      searchTimer = window.setTimeout(function () { search(query); }, 170);
    });
    input.addEventListener('keydown', function (event) { if (event.key === 'Escape') close(); });
  }

  function open() {
    if (!mobileQuery.matches) return;
    createModal();
    input.value = '';
    resetToPopular();
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cp-mobile-search-open');
    document.body.classList.add('cp-mobile-search-open');
    window.setTimeout(function () { input.focus(); }, 50);
  }

  function close() {
    if (!modal) return;
    if (searchController) searchController.abort();
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cp-mobile-search-open');
    document.body.classList.remove('cp-mobile-search-open');
  }

  document.addEventListener('click', function (event) {
    if (!mobileQuery.matches) return;
    var trigger = event.target.closest('.cp-mobile-bottom-nav__item[aria-label="ძიება"], .cp-compact-header__search button, .site-header__search-toggle, [data-cp-mobile-search-trigger]');
    if (!trigger) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open();
  }, true);

  document.addEventListener('submit', function (event) {
    if (!mobileQuery.matches || !event.target.matches('.cp-compact-header__search')) return;
    event.preventDefault();
    open();
  }, true);
})();